<template>
  <HeaderWarningPanel :visible="daysLeft !== null && daysLeft >= 0 && daysLeft < 10">
    {{ $tc('password_expires_in_days', daysLeft, { day: daysLeft }) }}.
  </HeaderWarningPanel>
</template>

<script>

import {mapState} from "vuex"
import moment from "moment-timezone"
import HeaderWarningPanel from "@/components/parts/general/HeaderWarningPanel.vue"

export default {
  name: "PasswordExpiresHeader",
  components: {
    HeaderWarningPanel
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
    }),
    validUntil() {
      return this.user?.password_valid_until || null
    },
    daysLeft() {
      if(!this.validUntil) return null
      let now = moment()
      return Math.ceil(moment(this.validUntil).diff(now, 'days', true))
    }
  }
}
</script>
